var map = {
	"./16_9.png": "7528",
	"./1_1.png": "3247",
	"./2_3.png": "e934",
	"./3_4.png": "40da",
	"./4_3.png": "5404",
	"./desktop.png": "a831",
	"./mobile.png": "998d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e91b";